import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[briksHost]',
})
export class BriksDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}